import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import LanguageDetector from 'i18next-browser-languagedetector';

import authFR from './fr/auth.json';
import commonFR from './fr/common.json';
import footerFR from './fr/footer.json';
import formFR from './fr/form.json';
import interventionFR from './fr/intervention.json';
import navigationFR from './fr/navigation.json';
import treetradeFR from './fr/treetrade.json';
import workerFR from './fr/worker.json';
import authNL from './nl/auth.json';
import commonNL from './nl/common.json';
import footerNL from './nl/footer.json';
import formNL from './nl/form.json';
import interventionNL from './nl/intervention.json';
import navigationNL from './nl/navigation.json';
import treetradeNL from './nl/treetrade.json';
import workerNL from './nl/worker.json';

export const locales = [`fr`, `nl`];

const content = {
  nl: {
    auth: authNL,
    common: commonNL,
    form: formNL,
    footer: footerNL,
    intervention: interventionNL,
    navigation: navigationNL,
    treetrade: treetradeNL,
    worker: workerNL,
  },
  fr: {
    auth: authFR,
    common: commonFR,
    form: formFR,
    footer: footerFR,
    intervention: interventionFR,
    navigation: navigationFR,
    treetrade: treetradeFR,
    worker: workerFR,
  },
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // pass i18n instance to react-i18next
  .use(initReactI18next)
  // initialize i18next
  .init({
    fallbackLng: locales,
    supportedLngs: locales,
    ns: ['common'],
    defaultNS: 'common',
    resources: content,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
